module.exports = __webpack_public_path__ + "static/img/notpublish.be253e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notpublish.png?v=20201104
// module id = orht
// module chunks = 1